import { DesktopRating, MobileRating } from '@cian/frontend-reviews-components';
import { Responsive } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './ObjectOverallRating.css';
import { InfoButton } from '../InfoButton/InfoButton';

export interface IObjectOverallRatingProps {
  formattedObjectTitle: string;
  value: number;
  reviewCount: number;
  onInfoClick?(): void;
}

export const ObjectOverallRating: React.FC<IObjectOverallRatingProps> = props => {
  const { value, formattedObjectTitle, reviewCount, onInfoClick } = props;

  return (
    <div
      itemScope
      itemProp="aggregateRating"
      itemType="http://schema.org/AggregateRating"
      data-testid="ObjectOverallRating"
      className={style['container']}
    >
      <meta itemProp="itemReviewed" content={formattedObjectTitle} />
      <meta itemProp="worstRating" content="1" />
      <meta itemProp="bestRating" content="5" />
      <Responsive phone tablet>
        <div className={style['mobile-rating']}>
          <MobileRating value={value} withRatingValue reviewCount={reviewCount} />
          <InfoButton onClick={onInfoClick} />
        </div>
      </Responsive>
      <Responsive desktop>
        <DesktopRating value={value} withRatingValue reviewCount={reviewCount} />
      </Responsive>
    </div>
  );
};
